export default {
  tabs: {
    home: 'Hjem',
    menu: 'Menu',
    orders: 'Ordrer',
  },
};
